import PropTypes from 'prop-types'
import { Component } from 'react'

export default class TableColumn extends Component {
  static propTypes = {
    align: PropTypes.oneOf(['left', 'right', 'center']),
    cellRenderer: PropTypes.func,
    dataGetter: PropTypes.func,
    dataKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    headerRenderer: PropTypes.func,
    label: PropTypes.string.isRequired
  }

  static defaultProps = {
    align: 'left'
  }

  render() {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error('Component <TableColumn /> should never render')
    }

    return null
  }
}



// WEBPACK FOOTER //
// ../src/components/TableColumn.js